import { render } from "./SelectCompanyFromLink.vue?vue&type=template&id=25a0a120"
import script from "./SelectCompanyFromLink.vue?vue&type=script&lang=js"
export * from "./SelectCompanyFromLink.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__